<!--
Copyright (c) 2026 Wind River Systems, Inc.

The right to copy, distribute, modify, or otherwise make use of this software may be licensed only pursuant to the terms of an applicable Wind River license agreement.
-->
<div class="content">
  <div class="heading">Recent Customers</div>

  <div class="table-holder">
    <table class="recent-customers">
      <thead>
        <tr>
          <th>User ID</th>
          <th>E-mail</th>
          <th>Licenses</th>
        </tr>
      </thead>
      <tbody>
        <tr
          *ngFor="let r of recentCustomers"
          (click)="onClickCustomer(r)"
          [ngClass]="r === selectedCustomer ? 'selected' : ''"
        >
          <td>{{ r.user_id }}</td>
          <td>{{ r.email }}</td>
          <td>{{ r.licenses?.join(', ') }}</td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="button-row">
    <button mat-raised-button class="select-button" (click)="selectCustomer()" [disabled]="!selectedCustomer">
      Select Customer
    </button>
    <button mat-raised-button class="cancel-button" (click)="cancel()">Cancel</button>
  </div>
</div>
